// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Libraries
import { Observable } from 'rxjs';
import { Select } from '@ngxs/store';

// Models
import { AppCleanup, LookUpResponse } from '../models';

import { LookupState } from '../state/lookup.state';

@Injectable({
	providedIn: 'root',
})
export class LookupService extends AppCleanup {
	lookUpUrl: string;

	constructor(private http: HttpClient) {
		super();
		this.lookUpUrl = `${this.apiUrl}api/lookup`;
	}

	getLookups(key?: string) {
		if (!key) {
			return this.http.get<LookUpResponse>(this.lookUpUrl);
		}
		return this.http.get<LookUpResponse>(`${this.lookUpUrl}?key=${key}`);
	}
}
